//external
import React, { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TableAction from 'components/v2/tableAction';
import EditIcon from '@material-ui/icons/Edit';
import RefreshIcon from '@material-ui/icons/Refresh';
import PrintIcon from '@material-ui/icons/Print';
//internal
import { startRequest, finishRequest } from 'store/modules/loading/actions';
import ContentPanel from 'components/ContentPanel';
import { setMessage } from 'store/modules/message/action';
import { sanitizeErrorUI } from 'utils/errorUtil';
import { formatDateTime } from 'utils/formatUtil';
import { showReport } from 'utils/reportUtil';
import DataTableReact from 'components/v2/dataTableReact';
import GridContainer from 'components/v2/grid';
import { useDebounce } from 'utils/uiUtils';
import InputText from 'components/v2/inputText';
import DataTableLoading from 'components/DataTableLoading';
import { FilterScheduleTodoRC } from '..';
import { getScheduleTodosRc, getAllows, getScheduleReport } from 'services/todoRc/service';
//style
import { IconContainer } from 'pages/nutrient/list/styled';

export default function Todo() {
  const message = useSelector(state => state.message.data);
  const salesmanId = useSelector(state => state.user.id );
  const [reload, setReload] = useState(0);
  const [dataTodoRc, setDataTodoRc] = useState();
  const [allows, setAllows] = useState({});
   //pagination
   const [totalRows, setTotalRows] = useState(0);
   const [perPage, setPerPage] = useState(10);
   const [sort, setSort] = useState();
 
  const dispatch = useDispatch();

  const { filter, setFilter } = useContext(FilterScheduleTodoRC);
 
  const debouncedSearchTodo = useDebounce(filter.search);
  
  const columns = [
    {
      name: 'Assunto',
      selector: 'subject',
      sortable: true,
    },
    {
      name: 'Data Inicial',
      selector: 'initialDate',
      sortable: true,
    },
    {
      name: 'Data Final',
      selector: 'finalDate',
      sortable: true,
    },
    {
      name: 'Usuário',
      selector: 'user',
      sortable: true,
    },
    {
      name: 'Vendedor',
      selector: 'salesman',
      sortable: true,
    },
    {
      style: {justifyContent: "flex-end"},
      cell: row => 
        <div>
          <IconContainer>
            <TableAction 
            title={"Editar"} 
            disabled={!allows.put} 
            to={`/schedule/schedule_todo_rc/view/${row.id}`}>
              <EditIcon/>
            </TableAction>
            <TableAction 
              title={"Imprimir"} 
              disabled={!allows.get} 
              onClick={() => handleClickPrint(row.id)}
              isLink={false}
            >
              <PrintIcon />
            </TableAction>
          </IconContainer>
        </div>
    }
  ]

  const actions = [
    <div style={{display: 'flex'}} key="actionsTodoRc">
      <TableAction 
      key='refresh'
      title={"Atualizar"} 
      onClick={refreshHandler}
      isLink={false}>
        <RefreshIcon/>
      </TableAction>
    </div>
  ];

  useEffect(() => {
    if (salesmanId) {
      dispatch(startRequest());
      getScheduleTodosRc(salesmanId, debouncedSearchTodo, perPage, filter.page, sort).then(data => {
        setTotalRows(parseInt(data.headers['recordcount']));
        setDataTodoRc(data.data.map(value => {
          value.initialDate = formatDateTime(value.initialDate);
          value.finalDate = formatDateTime(value.finalDate);
  
          return value;
        }));
      }).catch(err => {
        dispatch(setMessage(sanitizeErrorUI(err)));
      }).finally(() => {
        dispatch(finishRequest());
      });
      dispatch(startRequest());
      getAllows().then(data => {
        setAllows(data.data)
      }).catch(err => {
        dispatch(setMessage(sanitizeErrorUI(err)));
      }).finally(() => {
        dispatch(finishRequest());
      });
    }
  }, [dispatch, reload, salesmanId, debouncedSearchTodo, perPage, filter, sort]);

  function refreshHandler() {
    setReload(reload + 1);
  }

  const handlePerRowsChange = (perPage) => {
    setPerPage(perPage);
  };

  const handlePageChange = (page) => {
    setFilter({...filter, page});
  };

  const handleSort = (column, sortDirection) => {
    setSort(`${column.selector} ${sortDirection}`);
  };

  function handleClickPrint(id) {
    if (id) {
      dispatch(startRequest());
      getScheduleReport(id).then(res => {
        showReport(res.data);
      }).catch(err => {
        dispatch(setMessage(sanitizeErrorUI(err)));
      }).finally(() => {
        dispatch(finishRequest());
      });
    }
  }

  return (
    <ContentPanel title="Tarefas RC" message={message} actions={actions}>
      <GridContainer>
        <InputText
          xs={12}
          name="name"
          label="Pesquisar"
          type="text"
          placeholder="Pesquisar"
          value={filter.search}
          onChange={(e) => setFilter({page: 1, search: e.target.value})}
          hasWarning={false}
        />
        <DataTableReact
          noHeader
          columns={columns}
          data={dataTodoRc}
          pagination
          paginationServer
          progressComponent={<DataTableLoading />}
          paginationTotalRows={totalRows}
          onChangeRowsPerPage={handlePerRowsChange}
          onChangePage={handlePageChange}
          sortServer
          onSort={handleSort}
          paginationDefaultPage={filter.page}
        />
      </GridContainer>
    </ContentPanel>
  )
}